import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { FinancingJournalService } from '../../services'
import { FinancingJournal } from '../../models'

const log = new Logger('FinancingDetailResolver')
@Injectable({ providedIn: 'root' })
export class FinancingDetailResolver
  implements Resolve<Observable<FinancingJournal>> {
  constructor(
    private financingjournalService: FinancingJournalService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['id']
    
    return this.financingjournalService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/financing-journal']))
    )
  }
}
